export default (params) => ({
  trigger: {
    name: 'product_plus.close_overlay',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
          'free_drying',
        ],
      },
    },
    event: {
      name: 'close',
    },
    nonInt: true,
  },
});
